import type { ComputedRef } from 'vue'
import type { KidDiscipline } from './interfaces'

import { useListsStore } from '@shared/model'
import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useKidStore } from './store'

interface KidDisciplinesReturn {
  refDisciplines: ComputedRef<KidDiscipline[]>
  isAllDisciplinesAdded: ComputedRef<boolean>
  addDisciplineTooltip: ComputedRef<string>
  getDisciplineName: (code: string) => string
  getDisciplineUrl: (disciplineId: number) => string
  openAddDiscipline: () => void
}

export const useKidDisciplines = (): KidDisciplinesReturn => {
  const kidStore = useKidStore()
  const listsStore = useListsStore()

  const refDisciplines = computed<KidDiscipline[]>(() => kidStore.getDisciplines)

  const isAllDisciplinesAdded = computed<boolean>(() =>
    refDisciplines.value.length >= Object.keys(listsStore.getDiscipline?.code ?? {}).length,
  )

  const addDisciplineTooltip = computed<string>(() => (isAllDisciplinesAdded.value ? '' : 'Add discipline'))

  const getDisciplineName = (code: string): string => listsStore.getDiscipline?.code[code] ?? code

  const getDisciplineUrl = (disciplineId: number): string =>
    resolveUrl(AppRoute.DisciplinesGeneralInfo, { id: disciplineId }) ?? ''

  const openAddDiscipline = (): void => {
    kidStore.setModalAddDiscipline(true)
  }

  return {
    refDisciplines,
    isAllDisciplinesAdded,
    addDisciplineTooltip,
    getDisciplineName,
    getDisciplineUrl,
    openAddDiscipline,
  }
}
